/**
 * Toast — thin wrapper around Sonner.
 *
 * Usage:
 *   1. Mount <Toaster /> once in your app root (next to ThemeProvider).
 *   2. Call `toast.success("Готово")`, `toast.error("Ошибка")`, etc.
 *
 * The toaster reads the current document `class` to pick up dark mode.
 */
import { Toaster as Sonner } from "sonner";
import { useTheme } from "../../theme/use-theme";

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster(props: ToasterProps) {
  const { resolvedScheme } = useTheme();

  return (
    <Sonner
      theme={resolvedScheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
export { toast } from "sonner";
